import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';

import { Text, SplitScore, SplitText, RButton, PrintBox } from '../Base';
import { SPACE, FONT_SIZE } from '../Theme';
import { ScoreSummaryTable } from '../Table';

import { Header } from './Subcomponents';
// import { scoreSummaryData } from '../../Routes/MockExamDetails/mockData';

const ScoreLabel = ({ score, fullScore }) => (
  <Flex>
    <SplitText left="คะแนนรวมที่ได้" right="เต็ม" />
    <Box mx={SPACE.small} />
    <SplitScore score={score} fullScore={fullScore} fontSize={FONT_SIZE.semilarge} />
  </Flex>
);

const ScorePerSubsection = ({
  topics,
  maximumScore,
  minimumScore,
  averageScore,
  sdScore,
  title,
  score,
  fullScore,
  scoreVariant,
}) => {
  return (
    <PrintBox after={true}>
      <Box mb={SPACE.medium}>
        {title && (
          <Header
            left={title}
            right={<ScoreLabel score={score} fullScore={fullScore} />}
            bg="darkBlueLight"
            mt={SPACE.small}
          />
        )}
        <ScoreSummaryTable
          rows={topics}
          maxScore={maximumScore}
          minScore={minimumScore}
          averageScore={averageScore}
          sd={sdScore}
          scoreVariant={scoreVariant}
        />
      </Box>
    </PrintBox>
  );
};

const getSubsectionTables = (section, scoreVariant) => {
  const { subsections } = section;

  if (subsections.length === 1 && subsections[0].title === null) {
    const ss = subsections[0];
    return (
      <ScorePerSubsection
        {...section}
        scoreVariant={scoreVariant}
        title={null}
        topics={ss.topics}
      />
    );
  } else if (subsections.length > 0) {
    return (
      <Fragment>
        {subsections.map(ss => {
          return <ScorePerSubsection {...ss} scoreVariant={scoreVariant} />;
        })}
      </Fragment>
    );
  }

  return null;
};
export default class ScoreByTopics extends Component {
  static propTypes = {
    sections: PropTypes.array,
    onDownloadClick: PropTypes.func,
  };

  static defaultProps = {
    sections: [],
    onDownloadClick: () => {},
  };

  handleDownloadClick = () => {
    this.props.onDownloadClick();
  };

  render() {
    const { sections, scoreVariant, bannerFooter } = this.props;

    return (
      <Box mt={SPACE.large}>
        <PrintBox before={true}>
          <Flex justifyContent="space-between" alignItems="center" mb={SPACE.large}>
            <Text.Title>คะแนนตามบท</Text.Title>
          </Flex>
        </PrintBox>
        {sections.map((section, i) => (
          <Fragment key={`${section.id}_${i}`}>
            <Header
              left={section.title}
              right={<ScoreLabel score={section.score} fullScore={section.fullScore} />}
            />

            {section.subsections && getSubsectionTables(section, scoreVariant)}
          </Fragment>
        ))}
        {bannerFooter}
      </Box>
    );
  }
}
